import React, { useCallback } from 'react';
import { Link } from '@gravity-ui/uikit';
import { Key } from '../../types';
import { block } from '../../utils/cn';
import i18n from './i18n';
import './MarkItem.css';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var b = block('mark-item');
export function MarkItem(_ref) {
  var mark = _ref.mark,
    icon = _ref.icon,
    onClick = _ref.onClick,
    className = _ref.className;
  var onClickCallback = useCallback(function (event) {
    event.stopPropagation();
    event.preventDefault();
    onClick(mark);
  }, [mark, onClick]);
  var onKeyDownCallback = useCallback(function (event) {
    if (event.key === Key.ENTER) {
      event.stopPropagation();
      onClick(mark);
    }
  }, [mark, onClick]);
  return /*#__PURE__*/_jsx("span", {
    className: b(null, className),
    onClick: onClickCallback,
    onKeyDown: onKeyDownCallback,
    children: /*#__PURE__*/_jsxs(Link, {
      view: "secondary",
      className: b('link', className),
      children: [icon, " ", i18n(mark)]
    })
  });
}
// #sourceMappingURL=MarkItem.js.map